import { gql } from '@apollo/client';

const SUPPORT_FACILITY_FRAGMENT = gql`
  fragment SupportFacilityFragment on Facility {
    id
    name
    status
    arrears
    canViewFlaggedStudies
    programs {
      protectPlus
      renewalStock
    }
    enabledPrograms
    canUseIcor
    isCardioOne
    organization {
      id
    }
  }
`;

export default SUPPORT_FACILITY_FRAGMENT;
